import Routes from "./routes/index";
import "./styles.css";

export default function App() {
  return <Routes />;
}
